/**
 * Fair Home V2 — H11 scroll (YSL parity)
 * Ref audit: ysl.com = Swiper vertical + effect creative + mousewheel
 * Soft CSS snap was rejected — this is the real pager.
 */

/** Class on `document.documentElement` while Home v2 pager is mounted */
export const FAIR_HOME_V2_SCROLL_ROOT_CLASS = 'fair-home-v2-scroll'

/** Match YSL homepage creative transition (~500ms) */
export const FAIR_HOME_V2_PAGER_SPEED_MS = 500

/**
 * YSL creativeEffect (audited 2026-09-04):
 * next slides up from below; prev eases slightly in Z.
 */
export const FAIR_HOME_V2_PAGER_CREATIVE_EFFECT = {
  limitProgress: 1,
  shadowPerProgress: false,
  progressMultiplier: 1,
  perspective: true,
  prev: {
    translate: [0, 0, -1] as [number, number, number],
    rotate: [0, 0, 0] as [number, number, number],
    opacity: 1,
    scale: 1,
  },
  next: {
    translate: [0, '100%', 0] as [number, string, number],
    rotate: [0, 0, 0] as [number, number, number],
    opacity: 1,
    scale: 1,
  },
} as const

export const FAIR_HOME_V2_PAGER_MOUSEWHEEL = {
  enabled: true,
  releaseOnEdges: true,
  forceToAxis: true,
  sensitivity: 1,
  thresholdDelta: 10,
} as const

export const FAIR_HOME_V2_SCROLL_SNAP_SECTION_IDS = [
  'hero',
  'capsules',
  'services',
  'selected',
  'ai',
  'popular',
  'footer',
] as const

export type FairHomeV2ScrollSnapSectionId =
  (typeof FAIR_HOME_V2_SCROLL_SNAP_SECTION_IDS)[number]

export function isFairHomeV2ScrollSnapSection(
  id: string,
): id is FairHomeV2ScrollSnapSectionId {
  return (FAIR_HOME_V2_SCROLL_SNAP_SECTION_IDS as readonly string[]).includes(id)
}

/** Sections that may overflow one viewport — clip to 100dvh (YSL has no inner page scroll). */
export const FAIR_HOME_V2_PAGER_SCROLLABLE_SECTION_IDS = [] as const

export function isFairHomeV2PagerScrollableSection(id: string): boolean {
  return (FAIR_HOME_V2_PAGER_SCROLLABLE_SECTION_IDS as readonly string[]).includes(
    id,
  )
}
